var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('customer-detail',{attrs:{"customer":_vm.item,"ordersShowDestination":_vm.ordersShowDestination,"ordersEnableSearch":_vm.ordersEnableSearch,"isLoading":_vm.isLoading,"panelInfoTitle":'Dati Cliente'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }